<div class="contact-container">
  <h2>Give Feedback</h2>
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="name">Name</label>
      <input
        id="name"
        type="text"
        formControlName="name"
        class="form-control"
      />
      <div *ngIf="submitted && f['name'].errors" class="error">
        <small *ngIf="f['name'].errors?.['required']">Name is required.</small>
        <small *ngIf="f['name'].errors?.['minlength']"
          >Minimum 3 characters required.</small
        >
      </div>
    </div>

    <div class="form-group">
      <label for="email">Email</label>
      <input
        id="email"
        type="email"
        formControlName="email"
        class="form-control"
      />
      <div *ngIf="submitted && f['email'].errors" class="error">
        <small *ngIf="f['email'].errors?.['required']"
          >Email is required.</small
        >
        <small *ngIf="f['email'].errors?.['minlength']"
          >Invalid email format.</small
        >
      </div>
    </div>

    <div class="form-group">
      <label for="message">Message</label>
      <textarea
        id="message"
        formControlName="message"
        class="form-control"
      ></textarea>
      <div *ngIf="submitted && f['message'].errors" class="error">
        <small *ngIf="f['message'].errors?.['required']"
          >Message is required.</small
        >
        <small *ngIf="f['message'].errors?.['minlength']"
          >Minimum 10 characters required.</small
        >
      </div>
    </div>

    <button type="submit" class="btn">Send Message</button>
  </form>
</div>
